import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "listSettings" }
const _hoisted_2 = { class: "varBox" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Entry variables", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("option", { value: "number" }, "Number", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("option", { value: "string" }, "Text", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label hashtag" }, "#", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Add variable", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "varBox entries" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Entries", -1)
const _hoisted_12 = { class: "varName" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "add", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Add entry", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "label heading" }, "Entry offest", -1)
const _hoisted_17 = { class: "settings-row" }
const _hoisted_18 = { class: "input-box" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "X", -1)
const _hoisted_20 = { class: "input-box" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "Y", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = { class: "settings-row" }
const _hoisted_24 = { class: "input-box" }
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "Entries per page", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = { class: "label heading" }
const _hoisted_28 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createVNode("i", null, "#variableName"),
  /*#__PURE__*/_createTextVNode(" in any text-input within this template to use the corresponding variable. You can also use them in actions. Make sure that each variable is actually assined a value. In number-inputs you can press '#' to activate text-input (only avalable for some inputs). ")
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.entryType, (data, i) => {
        return (_openBlock(), _createBlock("div", {
          key: i,
          class: "settings-row"
        }, [
          _withDirectives(_createVNode("select", {
            "onUpdate:modelValue": $event => (data.type = $event)
          }, [
            _hoisted_4,
            _hoisted_5
          ], 8, ["onUpdate:modelValue"]), [
            [_vModelSelect, data.type]
          ]),
          _hoisted_6,
          _withDirectives(_createVNode("input", {
            class: "varName",
            type: "text",
            "onUpdate:modelValue": $event => (data.name = $event)
          }, null, 8, ["onUpdate:modelValue"]), [
            [_vModelText, data.name]
          ]),
          _createVNode("span", {
            class: "material-icons closeIcon",
            onClick: $event => (_ctx.component.entryType.splice(i, 1))
          }, "close", 8, ["onClick"])
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createVNode("div", {
        class: "btn",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.component.entryType.push({ name: 'varName', type: 'string' })))
      }, [
        _hoisted_7,
        _hoisted_8
      ])
    ]),
    _hoisted_9,
    _createVNode("div", _hoisted_10, [
      _hoisted_11,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.entries, (entry, i) => {
        return (_openBlock(), _createBlock("div", {
          key: i,
          class: "settings-row entry"
        }, [
          _createVNode("div", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.component.entryType, (variable, j) => {
              return (_openBlock(), _createBlock("div", {
                key: j,
                class: "entry-row"
              }, [
                _createVNode("span", _hoisted_12, "#" + _toDisplayString(variable.name) + " =", 1),
                (variable.type == 'number')
                  ? _withDirectives((_openBlock(), _createBlock("input", {
                      key: 0,
                      type: "number",
                      "onUpdate:modelValue": $event => (entry[variable.name] = $event)
                    }, null, 8, ["onUpdate:modelValue"])), [
                      [
                        _vModelText,
                        entry[variable.name],
                        void 0,
                        { number: true }
                      ]
                    ])
                  : _withDirectives((_openBlock(), _createBlock("input", {
                      key: 1,
                      type: "text",
                      "onUpdate:modelValue": $event => (entry[variable.name] = $event)
                    }, null, 8, ["onUpdate:modelValue"])), [
                      [_vModelText, entry[variable.name]]
                    ])
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode("span", {
            class: "material-icons closeIcon",
            onClick: $event => (_ctx.component.entries.splice(i, 1))
          }, "close", 8, ["onClick"])
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createVNode("div", {
        class: "btn",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.component.entries.push({})))
      }, [
        _hoisted_13,
        _hoisted_14
      ])
    ]),
    _hoisted_15,
    _hoisted_16,
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.component.xOffset = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.xOffset,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_19
      ]),
      _createVNode("div", _hoisted_20, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.component.yOffset = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.yOffset,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_21
      ])
    ]),
    _hoisted_22,
    _createVNode("div", _hoisted_23, [
      _createVNode("div", _hoisted_24, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.component.itemsAtOnce = $event))
        }, null, 512), [
          [
            _vModelText,
            _ctx.component.itemsAtOnce,
            void 0,
            { number: true }
          ]
        ]),
        _hoisted_25
      ])
    ]),
    _hoisted_26,
    _createVNode("div", _hoisted_27, " Show page (" + _toDisplayString(_ctx.component.drawOffset + 1) + "/" + _toDisplayString(_ctx.component.pageCount) + ") ", 1),
    _withDirectives(_createVNode("input", {
      type: "range",
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.component.drawOffset = $event)),
      max: _ctx.component.pageCount - 1
    }, null, 8, ["max"]), [
      [
        _vModelText,
        _ctx.component.drawOffset,
        void 0,
        { number: true }
      ]
    ]),
    _hoisted_28,
    _hoisted_29
  ]))
}